(function () {
  "use strict";

  // Avoid redefining if this script is loaded multiple times
  if (customElements.get("rcc-wishlist")) return;

  class RCCWishlistComponent extends HTMLElement {
    constructor() {
      super();
      this._product = null;
      this._hasRendered = false;
    }

    static get observedAttributes() {
      return ["product"];
    }

    get product() {
      return this._product;
    }

    set product(value) {
      if (!value || this._hasRendered) return;
      this._product = value;
      if (this.isConnected) {
        this.render();
      }
    }

    connectedCallback() {
      if (this._hasRendered) return;

      if (!this._product) {
        const productAttr = this.getAttribute("product");
        if (productAttr) {
          // Optional: support JSON string in attribute
          try {
            this._product = JSON.parse(productAttr);
          } catch {
            // If it's not JSON, ignore for now
          }
        }
      }

      this.render();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (this._hasRendered) return;
      if (name === "product" && newValue !== oldValue) {
        try {
          this._product = JSON.parse(newValue);
        } catch {
          this._product = null;
        }
        if (this.isConnected) {
          this.render();
        }
      }
    }

    render() {
      if (this._hasRendered) return;
      const product = this._product;
      if (!product || typeof product !== "object") return;

      const productId = this._extractId(product.id || product.productId);
      const variantId = this._extractId(
        (product.variants &&
          product.variants[0] &&
          product.variants[0].id) ||
          product.selectedVariantId ||
          product.variantId
      );

      
      if (!productId || !variantId) return;

      let handle = product.handle;
      if (!handle && product.url) {
        const urlMatch = product.url.match(/\/products\/([^?\/]+)/);
        if (urlMatch) handle = urlMatch[1];
      }

      const productUrl = this._resolveProductUrl(handle);

      this.innerHTML = `
        <button
          type="button"
          class="swym-button swym-add-to-wishlist-view-product swym-wishlist-collections-v2 product_${productId}"
          data-swaction="addToWishlist"
          data-with-epi="true"
          data-product-id="${productId}"
          data-product-url="${productUrl}"
          data-variant-id="${variantId}"
          aria-label="Add to wishlist"
          aria-pressed="false"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M19.6706 5.4736C17.6806 3.8336 14.7206 4.1236 12.8906 5.9536L12.0006 6.8436L11.1106 5.9536C9.29063 4.1336 6.32064 3.8336 4.33064 5.4736C2.05064 7.3536 1.93063 10.7436 3.97063 12.7836L11.6406 20.4536C11.8406 20.6536 12.1506 20.6536 12.3506 20.4536L20.0206 12.7836C22.0706 10.7436 21.9506 7.3636 19.6706 5.4736Z"
              stroke="#00a655" stroke-width="1.7px" fill="none"
              stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>
      `;

      // Optionally:
      // if (window._swat && _swat.initializeActionButtons) {
      //   _swat.initializeActionButtons(".rcc-search__grid");
      // }

      this._hasRendered = true;
    }

    _extractId(value) {
      if (!value) return null;
      if (typeof value === "number") return value;
      const match = String(value).match(/(\d+)(?!.*\d)/);
      return match ? match[1] : value;
    }

    _resolveProductUrl(handle) {
      const product = this._product || {};
      let url = product.url;
      if (!url && handle) {
        url = `/products/${handle}`;
      }
      if (!url) return "";
      if (/^https?:\/\//i.test(url)) return url;
      if (!url.startsWith("/")) {
        url = `/${url}`;
      }
      const origin =
        (typeof window !== "undefined" &&
          window.location &&
          window.location.origin) ||
        "https://www.ackermans.co.za";
      return `${origin.replace(/\/$/, "")}${url}`;
    }
  }

  customElements.define("rcc-wishlist", RCCWishlistComponent);
})();